module.exports = __webpack_public_path__ + "img/share_screen.43ec9d22.png";